<template>
  <v-container class="gerenciamento-grupos py-0 px-0" fluid>
    <v-row justify="end" class="pb-2">
      <mf-button label="Criar grupo" class="mr-2" @click="createNewGroup" />
      <importar-grupos-dialog class="pr-6" @success="getData()" />
    </v-row>
    <v-card>
      <v-card-text>
        <v-container fluid class="pa-0">
          <v-row class="pt-3">
            <v-col cols="9" class="pt-0 pl-6">
              <span class="table-card-title pl-0">Grupos</span> <br />
              <p class="subtitle pt-1" style="word-break: break-word">
                Alterações realizadas aqui serão aplicadas em todas as partes da Mercafacil que utilizam produtos, como a Gestão de ofertas e o seu Aplicativo
                por exemplo. Para aplicar ofertas no seu frente de caixa os produtos devem existir previamente no seu ERP.
              </p>
            </v-col>
            <v-col cols="3">
              <mf-search v-model="search" placeholder="Buscar grupo" />
            </v-col>
          </v-row>
        </v-container>
        <paginated-data-table
          ref="table"
          :headers="headers"
          :search="search"
          :query="query"
          :custom-items-per-page="10"
          queryName="productsGroups"
          :transformFunction="(item) => ({ loading: false, ...item })"
          :queryVariables="queryVariables"
          @update-options="updateVariables"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td class="d-flex align-center justify-center">
                <div v-if="item.image_url" class="header-img">
                  <img :src="item.image_url" />
                </div>
                <div v-else class="header-img d-flex align-center justify-center">
                  <mf-icon icon="image_not_supported" />
                </div>
              </td>
              <td class="column-group-text">
                {{ item.name }}
              </td>
              <td class="texto-corrido">{{ item.products_qty }}</td>
              <td class="texto-corrido">
                {{ `${DateTime.fromISO(item.updated_at).toFormat('dd/MM/yyyy | HH:mm')}` || '-' }}
              </td>
              <td>
                <mf-tooltip top>
                  <template #activator="{ on }">
                    <mf-button color="cinza-0" :loading="item.loading" icon="edit" type="icon" @click="searchGroup(item)" />
                  </template>
                  <span>Editar grupo</span>
                </mf-tooltip>
              </td>
              <td>
                <mf-tooltip top>
                  <template #activator="{ on }">
                    <mf-button color="cinza-0" icon="delete" type="icon" @click="deleteGroup(item._id)" />
                  </template>
                  <span> Deletar grupo </span>
                </mf-tooltip>
              </td>
            </tr>
          </template>
        </paginated-data-table>
      </v-card-text>
    </v-card>
    <dialog-upsert-products-group
      v-if="dialogUpsertGroup"
      :dialog.sync="dialogUpsertGroup"
      :group.sync="selectedGroup"
      :is-new="isNew"
      :categories-types="categoriesFilter"
      :categories="categories"
      @close="closeAndUpdate"
    />
  </v-container>
</template>

<script>
import orderBy from 'lodash/orderBy'
import {
  QUERY_GET_GROUPS,
  QUERY_GET_GROUP_PRODUCTS,
  MUTATION_DELETE_GROUP_PRODUCTS,
  PRODUCT_CATEGORIES_FINAL_CONSUMER,
  PRODUCT_CATEGORIES,
} from '../../graphql'
import { DateTime } from 'luxon'

export default {
  name: 'GerenciamenteGrupos',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    DialogUpsertProductsGroup: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/DialogUpsertProductsGroup.vue'),
    ImportarGruposDialog: () => import('@/modules/produtos/gerenciamento-produtos/views/pages/ImportarGruposDialog.vue'),
  },
  data: () => ({
    search: '',
    dialogUpsertGroup: false,
    selectedGroup: {},
    queryVariables: {
      sort: ['updated_at'],
      sortDirection: ['DESC'],
    },
    DateTime,
    categoriesFilter: [],
    isNew: false,
  }),
  computed: {
    query() {
      return QUERY_GET_GROUPS
    },
    headers() {
      return [
        {
          text: 'Imagem',
          value: 'image',
          width: '40px',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '55%',
          sortable: true,
        },
        {
          text: 'Quantidade de produtos',
          value: 'products_qty',
          width: '20%',
          sortable: true,
        },
        {
          text: 'Última atualização',
          value: 'updated_at',
          width: '15%',
          sortable: true,
        },
        {
          text: '',
          width: '5%',
          sortable: false,
        },
        {
          text: '',
          width: '5%',
          sortable: false,
        },
      ]
    },
  },
  apollo: {
    categories: {
      query: PRODUCT_CATEGORIES,
      update({ productCategories }) {
        const categories = orderBy(productCategories, 'name')
        return categories
      },
    },
    categoriesFilter: {
      query: PRODUCT_CATEGORIES_FINAL_CONSUMER,
      variables() {
        return {
          search: '',
        }
      },
      update({ categoriesFinalConsumer }) {
        const categories = orderBy(categoriesFinalConsumer, 'name')
        return categories
      },
    },
  },
  mounted() {
    this.$bus.$on('update', this.closeAndUpdate)
  },
  destroyed() {
    this.$bus.$off('update')
  },
  methods: {
    updateVariables(newQueryOptions) {
      const { sortBy, sortDesc } = newQueryOptions

      if (sortBy.length && sortDesc.length) {
        this.queryVariables.sort = sortBy
        this.queryVariables.sortDirection = sortDesc[0] ? 'DESC' : 'ASC'
      }
    },
    createNewGroup() {
      this.selectedGroup = {
        categories_final_consumer: {
          department: {},
          category: {},
          sub_category: {},
        },
      }
      this.isNew = true
      this.dialogUpsertGroup = true
    },
    searchGroup(item) {
      item.loading = true
      this.isNew = false
      this.$apollo
        .query({
          query: QUERY_GET_GROUP_PRODUCTS,
          fetchPolicy: 'no-cache',
          variables: {
            _id: item._id,
          },
        })
        .then(({ data: { productsGroup } }) => {
          item.loading = false
          this.editGroup(productsGroup)
        })
        .catch(() => this.$snackbar({ message: 'Erro ao buscar produtos.', snackbarColor: 'error' }))
    },
    editGroup(group) {
      if (group._id !== null) {
        this.selectedGroup = group
      } else {
        this.selectedGroup = {
          ...group,
          image_url: '',
          categories_final_consumer: {
            department: {},
            category: {},
            sub_category: {},
          },
        }
      }
      this.dialogUpsertGroup = true
    },
    closeAndUpdate(hasToRefresh) {
      this.dialogUpsertGroup = false

      if (hasToRefresh) {
        this.$refs.table.waitAndGetData()
      }
    },
    deleteGroup(id) {
      this.$confirm({
        title: 'Remover grupo',
        message: 'Tem certeza que deseja remover este grupo? Ele não poderá mais ser usado na criação de campanhas. Essa ação não pode ser desfeita.',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(async () => {
          try {
            await this.$apollo.mutate({
              mutation: MUTATION_DELETE_GROUP_PRODUCTS,
              variables: {
                _id: id,
              },
            })
            this.$snackbar({ message: 'Grupo deletado com sucesso.', snackbarColor: 'success' })
            this.$refs.table.waitAndGetData()
          } catch {
            this.$snackbar({ message: 'Erro ao deletar grupo. Tente novamente mais tarde.', snackbarColor: 'error' })
          }
        })
        .catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.gerenciamento-grupos {
  th {
    @extend .column-title;
  }
}
.icon-color {
  color: $cinza-l30;
}
.icon-delete:hover {
  color: $vermelho-0;
}
.icon-edit:hover {
  color: $marca-1;
}
.column-group-text {
  word-break: break-all;
  text-transform: none;
  font-size: 14px;
  font-weight: $font-weight-regular;
  line-height: $line-height-title;
  letter-spacing: $letterspacing-default;
  color: $cinza-0;
}

.header-img {
  max-width: 40px;
  height: 40px;

  img {
    object-fit: cover;
    max-width: 100%;
    height: 100%;
  }
}
</style>
